var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"color":"white","opacity":"1","z-index":"10","value":_vm.show}},[_c('v-img',{staticClass:"center fadein",attrs:{"src":require("@/assets/logo.svg"),"max-width":"600","min-width":"600"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }